<script lang="ts">
    import {
      Button,
      Form,
      FormGroup,
      Input,
      Label,
      Modal,
      ModalBody,
      ModalFooter,
      ModalHeader,
    } from "sveltestrap";
      import { Close, Modaltitle, SendMessage } from "../../../utils/Constant/Constant";
    let open:boolean = false;
    export let content : string;
    const toggle = () => (open = !open);
  </script>
  
  <Button color="primary" on:click={toggle}>Open modal for {content}</Button>
  <Modal isOpen={open} {toggle}>
    <ModalHeader {toggle}>{Modaltitle}</ModalHeader>
    <ModalBody>
      <Form>
        <FormGroup>
          <Label class="col-form-label" for="recipient-name">{"Recipient:"}</Label>
          <Input class="form-control" type="text" value={content} />
        </FormGroup>
        <FormGroup>
          <Label class="col-form-label" for="message-text">{"Message:"}</Label>
          <Input type="textarea" class="form-control" id="message-text" />
        </FormGroup>
      </Form>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" on:click={toggle}>{Close}</Button>
      <Button color="primary" on:click={toggle}>{SendMessage}</Button>
    </ModalFooter>
  </Modal>
  